/* resources/assets/js/components/pages/tester/tester.vue */
/* resources/assets/js/institution/features/statisticsmanagement/TestResults.vue */

import { Question } from 'Models'
import { ThemeMixin } from 'Mixins'

export default {
    mixins: [ThemeMixin],

    computed: {
        question() {
            return Question.currentQuestion()
        },
        isTextOnly() {
            return this.subCategory.isTextOnly()
        },
        showPrevButton() {
            return (
                this.currentModeConfig.showPrevBtn &&
                (this.isResultsView ||
                    !this.isRealTest ||
                    !this.profession.omitSubcatDialog())
            )
        },
    },
}
